import React, { ReactElement, ForwardedRef } from 'react';
import FormatService from '../../services/format-service';
import useStylesTextBlock from './text-block.styles';

const TextBlock: ReactMemoRefComponent = React.forwardRef((
  props: ReactComponentProps,
  ref: ForwardedRef<HTMLSpanElement>,
): ReactElement => {
  const {
    title,
    withWordBreak,
    className,
    children,
  } = props;

  const { classes } = useStylesTextBlock();

  const wordBreakClassName: string | undefined = withWordBreak ? classes.textBlockWordBreak : undefined;

  return (
    <span ref={ref} title={title} className={FormatService.formatClassNames(wordBreakClassName, className)}>
      {children}
    </span>
  );
});

export default TextBlock;
